/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import Tysiav2PostPayment from 'DesignSystem/Svgs/Tysiav2PostPayment/index'



/** @type {import('Simple/types.js').View} */
export default function Payment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/Content/TypeCell/Payment"
  
}) {
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="green"
 style="filled"
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<Tysiav2PostPayment
{...childProps}
  viewPath={`${viewPath}/Tysiav2PostPayment`}
 fill2={dtColorsGreen800}
 stroke={dtColorsGreen200}
 width={12}
 height={12}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Payment"
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}